import classNames from 'classnames';
import 'app/agriculture/components/Heading/Heading.scss';

interface HeadingProps {
    className?: string;
    children: string;
}

export function Heading({ className, children }: HeadingProps) {
    return <h2 className={classNames(className, 'Heading')}>{children}</h2>;
}
